import Temp from '@/courier/Temp'

export default class ThailandEcoPost extends Temp {

    static CODE = 'ECP';

    constructor() {
        super( ThailandEcoPost.CODE ); 
    }

    getZone( item ){
        let type
        let cross_price = 0
        let remote_area = 0

        type = super.checkZone( item.toPostcode );

        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }

    checkWeight( courierRates , item  , validate ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })
        
        return super.checkRules( item , validate );
    }
    
    async checkRemoteAreaByCorrectorDest(addressRemote, option) {
        return new Promise((resolve) => {
          super.getArea([addressRemote], ["ECP"], option).then((res) => {
            let weight = option.weight;
            let returnRate = {
              isRemote: 0,
              isTravelArea: 0,
              isIsland: res.data.ECP.is_island ? 15 : 0
            };        
            resolve(returnRate);
          });
        });
      }

}